export default {"src":"/_next/static/media/github.7efa3216.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};